function updateAcitiveClass( element, $triggers ) {
	$triggers.each( function() {
		jQuery( this ).removeClass( 'c-search-filter__trigger--active' );
	} );

	jQuery( element ).addClass( 'c-search-filter__trigger--active' );
}

function updateSearchResults( element, $container ) {
	const postType = element.dataset.filter;
	if ( 'all' === postType ) {
		$container.children().each( function() {
			const el = jQuery( this );
			el.removeClass( 'hidden' );
		} );
	} else {
		$container.children().each( function() {
			const el = jQuery( this );
			el.removeClass( 'hidden' );

			if ( ! el.hasClass( postType ) ) {
				el.addClass( 'hidden' );
			}
		} );
	}
}

jQuery( function( $ ) {
	const $triggers = $( '.c-search-filter__trigger' );

	if ( 0 < $triggers.length ) {
		const $searchWrapper = $( '#searchWrapper' );

		$triggers.on( 'click', function( e ) {
			e.preventDefault();
			updateAcitiveClass( this, $triggers );
			updateSearchResults( this, $searchWrapper );
		} );
	}
} );
